import { UserInteractionTypes } from '../../../common/store/store.types';
import {
  ACTION_READ_MORE_RESET_RECIRCULATION_DATA,
  ACTION_READ_MORE_SET_RECIRCULATION_DATA,
  ACTION_USER_INTERACTION
} from '../../../common/store/store.actions';

export const setUserInteraction = (interaction: UserInteractionTypes) => (dispatch): void => {
  dispatch({ type: ACTION_USER_INTERACTION, payload: interaction });
};

export const setRecirculationData = (currentScene: number, startOfCurrentScene: number, endOfCurrentScene: number) => (dispatch): void => {
  dispatch({ type: ACTION_READ_MORE_SET_RECIRCULATION_DATA, payload: { currentScene, endOfCurrentScene, startOfCurrentScene }});
};

export const resetRecirculationData = () => (dispatch): void => {
  dispatch({ type: ACTION_READ_MORE_RESET_RECIRCULATION_DATA });
};
